 function firstButton(e,el){
   var sibs = [];
    el.style.display='none';
    while (el = el.nextSibling) {
        if(el.id == "view-more-less-last"){
          el.classList.toggle('mystyle-2');
          console.log(el);
        };
        if(el.id == "view-more"){
          el.classList.toggle('mystyle');
          console.log(el);
        }; 
    }
  
}

function secondButton(e,el){
  el.classList.toggle('mystyle-2');
  var first = el;
  while (first = first.nextSibling) {
        if(first.id == "view-more-less-last-2"){
          first.classList.toggle('mystyle-2');
          console.log(el);
        };
  }
  while (el = el.previousSibling) {
        if(el.id == "view-more"){
          el.classList.toggle('mystyle');
          console.log(el);
      }; 
  }
   //el.previousElementSibling.previousElementSibling.classList.toggle('mystyle');
   //el.nextElementSibling.classList.toggle('mystyle-2');
   
}

function thirdButton(e,el){
   el.classList.toggle('mystyle-2');
  while (el = el.previousSibling) {
        if(el.id == "view-more-less-last"){
          el.classList.toggle('mystyle-2');
          console.log(el);
        };
        if(el.id == "view-more"){
          el.classList.toggle('mystyle');
          console.log(el);
        }; 
  }
   //el.previousElementSibling.previousElementSibling.previousElementSibling.classList.toggle('mystyle');
   //el.previousElementSibling.classList.toggle('mystyle-2');
  
}

(function() {
  // Şu anki URL'yi kontrol et
  if (window.location.href.includes('/pages/wholesale')) {
    // "announcement-bar" sınıfına sahip tüm elementleri bul
    const announcementBars = document.querySelectorAll('.announcement-bar');
    
    // Bulunan tüm elementleri gizle
    announcementBars.forEach(function(bar) {
      bar.style.display = 'none';
    });
  }
})();